
// App Proxy path (prefix/subpath from [app_proxy] in maxicare-flexplan-app).
const AGENT_SEARCH_URL = '/apps/maxicare/agent-search';

class AgentInput extends HTMLElement {
    // Set up a variable to hold the timeout ID
    timeoutId;

    disabled = '';
    hiddenInput;
    name = '';
    agentUsername;
    agentUsernameStatus;

    agent_type;
    agent_name;
    connectedCallback() {
        console.log(' connect ed call back agent input');
        // const maxi_agent = window.getCookie('maxi_agent');
        const maxi_agent = window.localStorage.getItem('maxi_agent');

      
        this.agent_type = window.localStorage.getItem('agent_type'); // November add
        this.agent_name = window.localStorage.getItem('agent_name'); // November add
        
      
        if (maxi_agent && maxi_agent.length > 0) {  // November add
            this.agent_type = 'Agent';  // November add
          
            const deepLink = window.b64_to_utf8(maxi_agent);
            const [agent,fullName] = deepLink.split('/');

          
            this.agent = agent;
            this.name = this.agent;
            if (fullName) {
                this.name = fullName;
            }
            this.disabled = 'disabled';

        }        
        this.renderContents(false);    
    }

    renderContents(parsedState) {
      this.hiddenInput = window.renderInputOutsideShadowRoot(this,'attributes[Agent Username]',this.agent)
      
      this.renderInputOutsideShadowRoot(this,'attributes[Agent Type]',this.agent_type) // November add
      this.renderInputOutsideShadowRoot(this,'attributes[Agent Name]',this.agent_name) // November add

        let templateContent = this.buildTemplate(this.label,this.name);
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.appendChild(templateContent);
        this.agentUsernameStatus = shadowRoot.getElementById('agent-username-status');
        this.agentUsername = this.shadowRoot.getElementById('agent-username');
        window.agentIsValid = !this.hiddenInput.value.trim().length;
        if (this.hiddenInput.value.trim().length > 0) {
          this.agentUsername.value = this.hiddenInput.value 
          let agentSalesLinked = shadowRoot.getElementById('agent-sales-linked');
          agentSalesLinked.innerHTML = "Sales Linked";
        }
        this.attachEventHandlers();

        
    }



  // Begin November add


    renderInputOutsideShadowRoot(container,name,value) {
    
      let input = container.querySelector(`input[name='${name}']`);
      if (!input) {
        input = container.ownerDocument.createElement("input");
        input.type = "hidden";
        input.setAttribute('form','cart');
        container.appendChild(input);
      }
      input.name = name;
      input.value = value || "";
    
      return input;
    }

  
  // End November add

    attachEventHandlers() {
        this.agentUsername
            .addEventListener('input',e => {
                
              
                this.hiddenInput.value = e.target.value


              // Clear any existing timeout
              clearTimeout(this.timeoutId);
              
              // Start a new timeout of 1 second
              this.timeoutId = setTimeout(() => {
                // Call the API using the text in the input field
                let username = this.agentUsername.value.trim();
                if (!username.length) {
                  this.agentUsernameStatus.innerHTML = '';
                  return;
                }
                // Shopify App Proxy -> members-src /shopify-proxy/agent-search (OHI agent search)
                fetch(AGENT_SEARCH_URL + '?username=' + encodeURIComponent(username), {
                  headers: { 'Accept': 'application/json' }
                })
                  .then(response => response.json())
                  .then(result => {
                    // Handle the API result
                    window.agentIsValid = true;
                    window.agentIsFilledUp = true;
                    if (result && result.valid === true) {
                      this.agentUsernameStatus.innerHTML ="Your Agent Username is valid. Thank you for choosing Maxicare."
                    } else {
                      this.agentUsernameStatus.innerHTML = '';
                      // this.agentUsernameStatus.innerHTML = `${username}`.trim().length ? "<span style=\"color:#F02736;\">Your Agent Username is invalid. Kindly provide a valid Agent Username.</span>" : '';
                      // window.agentIsValid = !`${username}`.trim().length;
                      // window.agentIsFilledUp = !!`${username}`.trim().length;
                    }
                  })
                  .catch(error => {
                    // Handle any errors
                  });
              }, 1000);
            })
    }


    get agent() {
        return this.getAttribute('agent');
    }

    set agent(value) {
        this.setAttribute('agent',value);
    }
    get label() {
        return this.getAttribute('label');
    }

    set label(value) {
        this.setAttribute('label',value);
    }


    static get observedAttributes() {
        return ['agent','label'];
      }
    


    buildTemplate(label,agent) {
        const template = document.createElement('template');
        template.innerHTML = `<p class="cart-attribute__field">
            <span id="agent-sales-linked" style="color: green; font-weight: bold; font-style: italic"></span>
            <br/>
            <label for="agent-username">${label}</label>
            <input id="agent-username" class="cart-attribute-custom"
                value="${agent}" ${this.disabled} />
            <span id="agent-username-status" style="color: blue; font-weight: bold; font-style: italic"></span>
        </p>`;
        return template.content;
    }

}

customElements.define('maxi-agent-input', AgentInput);